import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components";

import DsTag from "ds/Tag";

export const Wrapper = styled.div`
  padding: 16px 24px;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

export const Link = styled(RouterLink)`
  text-decoration: none;
`;

export const Tag = styled(DsTag)`
  align-self: start;
`;
